<script setup>
import ticker from "@/components/App/ticker.vue";
import headerDefault from "@/components/App/header-default/header-default.vue";
import footerDefault from "@/components/App/footer/footer.vue";
import productImagePreview from "@/components/App/product-image-preview.vue";

import {
    ref,
    reactive,
    computed,
    onBeforeMount,
    onMounted,
    onBeforeUnmount,
    watch,
    inject,
    useTemplateRef,
    onUpdated,
    nextTick,
    onUnmounted
} from 'vue';
import { useCommonComposable } from '@/composables/commonComposable.js';
import { useColor } from '@/composables/useColor'
const { darkenColor, lightenColor } = useColor()
import { useStore } from 'vuex';
import {onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter} from 'vue-router';
import { useHead } from "@vueuse/head";
import axios from "axios";
import product from "@/store/modules/product";
import PopularProducts from "@/components/App/Mobile/popular-products.vue";
import Preloader from "@/components/App/preloader.vue";
import KeyboardShortcut from "@/components/App/KeyboardShortcut.vue";

import teamsNavigate from '@/data/leagues'
import FeaturedCategories from "@/views/App/MainPage/components/featured-categories.vue";
import TypingText from "@/components/App/typing-text.vue";

const notify = inject('notify');

const store = useStore();
const router = useRouter();
const route = useRoute();

const { setImageURL, setImageThumbURL, categories, getCategories, sizes, isMobile, getDiscountValue } = useCommonComposable();

const isLoading = ref(true);

useHead({
    title: `Baller — интернет-магазин оригинальных джерси, купить оригинальную футбольную форму`,
    meta: [
        { name: 'description', content: "Описание страницы" },
        { property: 'og:title', content: 'Baller — интернет-магазин оригинальных джерси' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://ballershop.ru/' }
    ],
})

const handleBodyMouse = () => {
    if (!addBanner1 || !addBanner2 || !addBanner1.value || !addBanner2.value) return
    addBanner1.value.style.right = '20px'
    setTimeout(() => {
        if (addBanner1.value)
        addBanner1.value.style.transitionDuration = '200ms'
    }, 200)

    addBanner2.value.style.left = '50px'
    setTimeout(() => {
        if (addBanner2.value)
            addBanner2.value.style.transitionDuration = '200ms'
    }, 200)
};

const handleKeys = (event) => {
    if (event.key === 'ArrowLeft') {
        event.preventDefault();
        prevProduct()

    } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        nextProduct()
    }
};

onMounted(async () => {
    await store.dispatch("category/fetchMainCategory");
    await nextTick( () => {
        mainCategory.value = store.state.category.mainCategory[0];

        if (!mainCategory.value) {
            // isShowMainCat = false
        } else {
            if (!targetBtn.value) return
            targetBtn.value.style.clipPath = setClipBuy.value
        }
    })
    await store.dispatch("fetchImages", {categoryName: mainCategory.value['category_name']})
    mainCategory.value.image = store.state.images[0]

    await getCategories(['Товар недели', 'Популярное'])
    await getImages()

    catWeek.value = categories.value.find(item => item.category_name === 'Товар недели')
    catPopular.value = categories.value.find(item => item.category_name === 'Популярное')

    await store.dispatch("product/fetchProducts", {limit: 12})
    products.value = store.state.product.products

    const uniqueProductCodes = [...products.value.map(item => item["Код"])];
    await fetchImages(uniqueProductCodes, products.value);

    // смена изображения, блок смотреть ещё
    otherProductsInterval = setInterval(() => {
        if (!otherProductsImages.value.length) return

        currentOtherProductImage.value =
            (currentOtherProductImage.value + 1) %
            otherProductsImages.value.length
    }, 3000)

    await getLatestBallerArticle()

    isLoading.value = false


    if (animationTextContainer.value) animationTextContainer.value.style.height = animationText.value.getBoundingClientRect().height + 'px';

    setMessageIcn()
    if (localStorage.getItem('isSendReqJersey')) {
        isSendReqJersey.value = JSON.parse(localStorage.getItem('isSendReqJersey'))
    }


    prepareLines();
    startTyping();

    document.body.addEventListener('mousemove', handleBodyMouse, );
    document.body.addEventListener('wheel', handleScroll, { passive: false });
    window.addEventListener('keydown', handleKeys);
    window.addEventListener('resize', updateCardWidth);
})

onUnmounted(() => {
    document.body.removeEventListener('mousemove', handleBodyMouse, );
    document.body.removeEventListener('wheel', handleScroll, { passive: false });
    window.removeEventListener('keydown', handleKeys);
    window.removeEventListener('resize', updateCardWidth);

    clearInterval(otherProductsInterval)
})

onBeforeRouteLeave((to, from, next) => {
    document.body.removeEventListener('mousemove', handleBodyMouse, );
    document.body.removeEventListener('wheel', handleScroll, { passive: false });
    next()
});

const prepareLines = () => {
    const textArray = fullText.value.split('\n').map((line) => line.trim());
    for (let i = 0; i < textArray.length; i++) {
        lines.value.push('');
    }
};

const startTyping = () => {
    intervalId.value = setInterval(() => {
        if (
            currentCharIndex.value >= getCurrentLine().length &&
            currentLineIndex.value === lines.value.length - 1
        ) {
            clearInterval(intervalId.value); // Завершаем анимацию
            return;
        }

        let currentLine = getCurrentLine();
        if (currentLine[currentCharIndex.value]) {
            lines.value[currentLineIndex.value] += currentLine[currentCharIndex.value];
            currentCharIndex.value++;
        } else {
            currentLineIndex.value++; // Переходим к следующей строке
            currentCharIndex.value = 0;
        }
    }, 100); // Интервал набора символов
};

const getCurrentLine = () => {
    return fullText.value.split('\n')[currentLineIndex.value].trim();
};

const products = ref([])

const targetBtn = useTemplateRef('targetBtn')
const textReqJersey = useTemplateRef('textReqJersey')
const messageIcn = useTemplateRef('messageIcn')

const addBanner1 = useTemplateRef('add-banner-1')
const addBanner2 = useTemplateRef('add-banner-2')
const addBanner3 = useTemplateRef('add-banner-3')
const addBanner4 = useTemplateRef('add-banner-4')
const addBanner5 = useTemplateRef('add-banner-5')
const addBanner6 = useTemplateRef('add-banner-6')
const addBanner7 = useTemplateRef('add-banner-7')
const addBanner8 = useTemplateRef('add-banner-8')
const mainBanner = useTemplateRef('main-banner')

const mainCategory = ref('')
let catWeek = ref({});
let catPopular = ref({});

const isSendReqJersey = ref(false);

const animationTextContainer = useTemplateRef('animationTextContainer');
const animationText = useTemplateRef('animationText');

const getCardImage = (name) => {
    try {
        return require(`@/assets/images/${name}`);
    } catch (error) {
        return '/image.png'
    }
}

const socials = ref([
    {
        name: 'Email',
        icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M10 20H15V18H10C5.66 18 2 14.34 2 10C2 5.66 5.66 2 10 2C14.34 2 18 5.66 18 10V11.43C18 12.22 17.29 13 16.5 13C15.71 13 15 12.22 15 11.43V10C15 7.24 12.76 5 10 5C7.24 5 5 7.24 5 10C5 12.76 7.24 15 10 15C11.38 15 12.64 14.44 13.54 13.53C14.19 14.42 15.31 15 16.5 15C18.47 15 20 13.4 20 11.43V10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20ZM10 13C8.34 13 7 11.66 7 10C7 8.34 8.34 7 10 7C11.66 7 13 8.34 13 10C13 11.66 11.66 13 10 13Z" fill="black"/>\n' +
            '</svg>',
        id: 'email.icn',
        link: 'mailto:hello@ballershop.ru',
        color: '#DC33DF'
    },
    {
        name: 'Telegram',
        icon: '<style>.card svg { width: 100% !important; height: 100% !important} path {transition: all 300ms ease-in-out}</style><svg width="18" height="16" id="tg-icn" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M15.13 2.30561C15.6879 2.09326 15.9654 2.01721 16.1178 1.98955C16.1191 2.04223 16.1185 2.08239 16.116 2.11005C15.8977 4.52394 14.9391 10.4629 14.4461 13.2264C14.3313 13.8733 14.2429 14.1815 13.6465 13.8141C13.2551 13.5721 12.9014 13.2679 12.5213 13.0071C11.2748 12.1488 9.49117 10.8718 9.63792 10.9488C8.41118 10.0994 8.92483 9.57988 9.6097 8.88653C9.71977 8.77492 9.83548 8.65837 9.94837 8.53491C9.99918 8.4796 10.2466 8.23861 10.5947 7.89786C11.7123 6.80746 13.8723 4.69876 13.9268 4.4548C13.9362 4.4153 13.9438 4.26517 13.86 4.18714C13.7754 4.10813 13.6502 4.13479 13.5609 4.15652C13.4336 4.18681 11.4034 5.59557 7.47043 8.38281C6.89469 8.79764 6.37288 8.99978 5.90501 8.98925L5.90972 8.99221C5.29352 8.76405 4.67921 8.56751 4.06207 8.36997C3.65311 8.24105 3.24543 8.10771 2.83909 7.96996L2.54934 7.87317C6.80814 5.92546 9.64451 4.64345 11.066 4.0222C13.13 3.12045 14.3549 2.60191 15.13 2.30561ZM17.4095 0.401361C17.2093 0.234826 16.9758 0.117998 16.7265 0.0596235C16.5384 0.0122148 16.3596 -0.00260083 16.2251 0.000362217C15.7763 0.00826366 15.2956 0.141601 14.4885 0.448769C13.6653 0.762852 12.4009 1.30015 10.3435 2.19795C8.89159 2.83204 6.00599 4.1371 1.68667 6.11312C1.3066 6.27214 0.959467 6.45288 0.684766 6.66622C0.430763 6.86474 0.0760984 7.21932 0.0111863 7.76255C-0.0377329 8.17342 0.0760984 8.55269 0.307524 8.85196C0.508845 9.11172 0.766612 9.26975 0.96323 9.3695C1.25486 9.51765 1.6481 9.64704 1.99336 9.76062C2.53241 9.93841 3.06958 10.1192 3.61051 10.293C5.28317 10.8303 6.66044 11.2728 8.17505 12.3217C9.28608 13.0901 10.3764 13.8921 11.4893 14.6585C11.8957 14.938 12.2749 15.259 12.6935 15.5178C13.1526 15.7993 13.734 16.0571 14.4433 15.9889C15.5139 15.8852 16.0708 14.8511 16.2966 13.5889C16.7867 10.8332 17.7613 4.81234 17.9899 2.29771C18.0108 2.00591 17.9992 1.71256 17.9551 1.42361C17.8994 1.02393 17.7051 0.659908 17.4095 0.401361Z" fill="#1C1C1C"/>\n' +
          '</svg>',
        id: 'tg-icn',
        link: 'https://t.me/ballerjersey',
        color: '#29A9EA'
    },
    {
        name: 'ВКонтакте',
        icon: '<svg id="vk-icn" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.26 1.26C2.38419e-07 2.532 0 4.566 0 8.64V9.36C0 13.428 2.38419e-07 15.462 1.26 16.74C2.532 18 4.566 18 8.64 18H9.36C13.428 18 15.462 18 16.74 16.74C18 15.468 18 13.434 18 9.36V8.64C18 4.572 18 2.538 16.74 1.26C15.468 2.38419e-07 13.434 0 9.36 0H8.64C4.572 0 2.538 2.38419e-07 1.26 1.26ZM3.036 5.478H5.1C5.166 8.91 6.678 10.362 7.878 10.662V5.478H9.816V8.436C10.998 8.31 12.246 6.96 12.666 5.472H14.598C14.4404 6.24222 14.1256 6.97167 13.6735 7.61481C13.2213 8.25796 12.6414 8.80099 11.97 9.21C12.7194 9.58287 13.3813 10.1104 13.9118 10.7579C14.4424 11.4053 14.8297 12.1579 15.048 12.966H12.918C12.462 11.544 11.322 10.44 9.816 10.29V12.966H9.576C5.472 12.966 3.132 10.158 3.036 5.478Z" fill="#1C1C1C"/>\n' +
            '</svg>\n',
        id: 'vk-icn',
        link: 'https://vk.com/ballerjersey',
        color: '#0077FF'
    },
    {
        name: 'Спортс"',
        icon: '<svg id="sports-icn" width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M4.3728 1.91991L1.7645 7.22103H0V4.45599V0H10.0499L6.5208 7.22103H4.7563V1.91991H4.3728Z" fill="#1C1C1C"/>\n' +
            '</svg>\n',
        id: 'sports-icn',
        link: 'https://www.sports.ru/tribuna/blogs/ballerblog',
        color: '#00C78B',
    }
])

const fullText = ref(`
        Слово blokecore-культуры в России.
        Baller — твоё оригинальное джерси
      `)
const lines = ref([])
const currentLineIndex = ref(0)
const currentCharIndex = ref(0)
const intervalId = ref(null)

const setClipBuy = computed(() => {
    // Реализация необычной формы кнопки

    if (!targetBtn.value) return

    const btn = targetBtn.value

    const height = parseInt(getComputedStyle(btn).height);
    const width = parseInt(getComputedStyle(btn).width);
    const pr = height/width

    let bph = 4; /* border percent height */
    let bpw = pr * bph
    let o = 2.5; /* otklonenie */

    let ILT = `${0 + (width/100*bpw)}px ${0 + (height/100*bph)}px`;
    let ILB = `${0 + (width/100*bpw)}px ${height - (height/100*bph)}px`;
    let OLM = `${0}px ${height - (height/100*bph)}px`;
    let OLT = `${0}px ${0}px`;
    let ORT = `${width}px ${0}px`;
    let ORB = `${width - (width/100*o)}px ${height}px`;
    let OLB = `${0}px ${height}px`;
    // OLM
    let IRB = `${width - (width/100*bpw) - (width/100*o)}px ${height - (height/100*bph)}px`;
    let IRT = `${width - (width/100*bpw)}px ${0 + (height/100*bph)}px`;
    // ILT

    return `polygon(${ILT}, ${ILB}, ${OLM}, ${OLT}, ${ORT}, ${ORB}, ${OLB}, ${OLM}, ${IRB}, ${IRT}, ${ILT})`
})

const setMessageIcn = () => {
    if (!messageIcn.value) return
    messageIcn.value.style.bottom = `-${messageIcn.value.getBoundingClientRect().height/1.4}px`
    messageIcn.value.style.left = `${messageIcn.value.parentElement.getBoundingClientRect().width*0.75}px`
}

const
    getImages = async () => {
    if (categories.value.length > 0) {
        for (let cat of categories.value) {
            if (cat.items.length > 0) {
                for (let item of cat.items) {
                    await store.dispatch('fetchImages', {
                        productCode: item.code
                    })
                    item.imageUrl = store.state.images[0]
                    item.images = store.state.images
                }
            }
        }
    }
}

const fetchImages = async (productCodes, products) => {
    try {
        const config = { headers: { 'Cache-Control': 'no-cache' } };
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/products/getProductImages`, {
            params: { productCodes }, // Массив передается под именем productCodes
            ...config
        });

        const renameKeys = obj => {
            return {
                'ID': obj.image_id,
                'Ссылка': obj.image_url,
                'Тип': obj.image_type,
                'Товар': obj.product_code,
                'Имя товара': obj.product_name,
                'Страница': obj.page_id,
                'Текст': obj.image_text
            };
        };

        // Преобразуем полученные данные
        const imagesByProduct = {};
        for(const img of response.data) {
            const key = img.product_code;
            if (!imagesByProduct[key]) {
                imagesByProduct[key] = []; // создаём новый список изображений для конкретного товара
            }
            imagesByProduct[key].push(renameKeys(img));
        }

        // Связываем каждое изображение с соответствующими товарами
        products.forEach(product => {
            const productId = product['Код'];
            const images = imagesByProduct[productId];

            if(images) {
                product.images = images;
                product.imageUrl = images.find(image => image["Тип"] === 'Заглавная'); // добавляем ссылку заглавного изображения
            } else {
                // console.warn(`Нет изображений для продукта с кодом ${productId}`);
            }
        });

    } catch (e) {
        console.error(e);
    }
}

const sendReq = async () => {
    if (isSendReqJersey.value) return
    if (textReqJersey.value.value.length < 10) {
        notify('Некорректный запрос. Используйте от 10 символов')
    } else {
        const html = `<div><h1>Новый запрос от пользователя на сайте:</h1><p>${textReqJersey.value.value}</p></div>`

        const response = await axios.post(process.env.VUE_APP_API_URL + "/mail/sendMsg", {
            to: 'hello@ballershop.ru',
            subject: 'Запрос от пользователя — Baller',
            html: html
        })

        if (response.status === 200) {
            notify('Запрос отправлен')
            localStorage.setItem('isSendReqJersey', true);
            isSendReqJersey.value = true
        } else {
            notify('Произошла техническая ошибка. Попробуйте позже')
        }
    }
}


let isPreventScroll = true;
const sumScrollBanner = ref(0)

const bannerRibbon = useTemplateRef('banner-ribbon')

// Функция обработки события прокрутки
const handleScroll = (event) => {
    if (!mainBanner.value || !isPreventScroll || !bannerRibbon.value) return;

    const rect = bannerRibbon.value.getBoundingClientRect();
    const stickyHeight = window.innerHeight;
    const scrollPath = rect.height - stickyHeight;

    const currentYOffset = document.documentElement.scrollTop || document.body.scrollTop

    if (rect.top <= 0 && rect.bottom >= stickyHeight) {
        // Прогресс прокрутки (от 0 до 1)
        let progress = Math.abs(rect.top) / scrollPath;
        progress = Math.min(Math.max(progress, 0), 1);

        if (progress < 0.4) {
            addBanner3.value.style.left = '20vw'
        } else if (progress < 0.6 && progress > 0.5) {
            addBanner4.value.style.right = '35vw'
        } else if (progress < 0.7 && progress > 0.6) {
            addBanner6.value.style.left = '10vw'
        } else if (progress < 0.8 && progress > 0.7) {
            addBanner5.value.style.right = '5vw'
        } else if (progress < 0.9 && progress > 0.8) {
            addBanner7.value.style.right = '45vw'
        } else if (progress > 0.95 && event.deltaY < 0) {
            let oldValue = bannerRibbon.value.offsetHeight;
            bannerRibbon.value.style.height = 'auto'
            let newValue = bannerRibbon.value.offsetHeight;

            document.body.scrollTo({
                top: currentYOffset - (oldValue - newValue) + event.deltaY,
                behavior: 'instant'
            });

            event.preventDefault();
        }
    }
};

const activeProductIndex = ref(0);
const nextProduct = () => {
    if (currentPage.value < maxPage.value) {
        currentPage.value++;
    }
};

const prevProduct = () => {
    if (currentPage.value > 0) {
        currentPage.value--;
    }
};


// background смотреть ещё, блок новинки
const currentOtherProductImage = ref(0)
const otherProductsImages = computed(() => {
    return products.value
        .slice(9, 12)
        .map(product => setImageThumbURL(product.imageUrl))
        .filter(Boolean)
})

let otherProductsInterval = null

const handleMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // диапазон поворота ±10°
    const rotateY = ((x / rect.width) - 0.5) * 20;
    const rotateX = (0.5 - y / rect.height) * 20;

    card.style.transform = `
        perspective(1000px)
        rotateX(${rotateX}deg)
        rotateY(${rotateY}deg)
        scale(1.02)
    `;
};

const resetCard = (e) => {
    e.currentTarget.style.transform = `
        perspective(1000px)
        rotateX(0deg)
        rotateY(0deg)
        scale(1)
    `;
};

const visibleCount = ref(5);
const currentPage = ref(0);

const maxPage = computed(() =>
    Math.max(0, catPopular.value.items.length - visibleCount.value)
);

const trackRef = ref(null);
const cardWidth = ref(0);

const trackStyle = computed(() => ({
    transform: `translateX(-${currentPage.value * cardWidth.value}px)`
}));

const updateCardWidth = () => {
    const firstCard = trackRef.value?.querySelector('.product-item__card');

    if (!firstCard) return;

    const styles = getComputedStyle(trackRef.value);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);

    cardWidth.value = firstCard.offsetWidth + gap;
};

// блок популярных команд
const activeLeagueIndex = ref(0);
const activeLeague = computed(() => {
    return teamsNavigate.value[activeLeagueIndex.value];
});
const selectLeague = (index) => {
    activeLeagueIndex.value = index;
};

// trending searches
const trendingSearches = ref(['«ПСЖ»', 'Испания', 'Аргентина', '«Барселона»', '«Манчестер Юнайтед»']);

const { useTypingAnimation } = useCommonComposable();
const { typedText } = useTypingAnimation(
    () => ['Реал Мадрид 2015/16', 'Total 90', 'Adidas', 'Манчестер Юнайтед 1999', 'Лионель Месси', 'Siemens Mobile'], {
        maxLength: isMobile.value ? 20 : null
    }
);

const searchText = ref('')
const searchInput = ref('')
const focusSearch = () => {
    searchInput.value?.focus();
};

const latestArticle = ref(null);

const getLatestBallerArticle = async () => {
    try {
        const { data } = await axios.get(
            `${process.env.VUE_APP_API_URL}/sports/getLatestBallerArticle`
        );

        latestArticle.value = data;

    } catch (error) {
        console.error(
            'Не удалось получить последнюю статью Baller',
            error
        );
    }
};

watch(
    () => catPopular.value?.items,
    async (items) => {
        if (!items?.length) return;

        await nextTick();
        updateCardWidth();
    },
    { immediate: true }
);

const enterSearch = (text) => {
    router.push({ path: '/products' , query: {searchText: text} });
}

</script>

<template>
    <preloader v-if="isLoading" :is-loading="isLoading"></preloader>
    <div class="silver-background">
        <ticker></ticker>
        <header-default></header-default>

        <div class="text-animation">
            <h1 style="text-align: center; display: flex; flex-direction: column; align-items: center">
                <span v-for="line in lines" :class="{ 'typing': true }" style="font-weight: 500; font-size: 54px">{{ line }}</span>
            </h1>
            <router-link :to="{name: 'products'}" class="main-page_target-btn-outer">
                <div class="main-page_target-btn">
                    <p>Дроп!</p>
                </div>
            </router-link>

            <div class="pic-banner-ribbon" ref="banner-ribbon" v-if="!isMobile">
                <div class="pic-banner">
                    <div class="glitch-img" ref="main-banner">
                        <img ref="main-banner" id="main-banner" :src="getCardImage('main-banner.png')" alt="">
                    </div>
                    <img ref="add-banner-1" class="add-banner" id="add-banner-1" :src="getCardImage('main-banner-add1.png')" alt="">
                    <img ref="add-banner-2" class="add-banner" id="add-banner-2" :src="getCardImage('main-banner-add2.png')" alt="">
                    <img ref="add-banner-3" class="add-banner" id="add-banner-3" :src="getCardImage('main-banner-add3.png')" alt="">
                    <img ref="add-banner-4" class="add-banner" id="add-banner-4" :src="getCardImage('main-banner-add4.png')" alt="">
                    <img ref="add-banner-5" class="add-banner" id="add-banner-5" :src="getCardImage('main-banner-add5.png')" alt="">
                    <img ref="add-banner-6" class="add-banner" id="add-banner-6" :src="getCardImage('main-banner-add6.png')" alt="">
                    <img ref="add-banner-7" class="add-banner" id="add-banner-7" :src="getCardImage('main-banner-add7.png')" alt="">
                </div>
            </div>
        </div>

        <popular-products :products="catPopular.items" v-if="isMobile"></popular-products>

        <div class="container page column-page" id='m-page'>

            <div class="hype-products__container" v-if="!isMobile" v-reveal>
                <keyboard-shortcut :description="'Листай'" :keys="['←', '→']" :is-typing="true" :is-mini="false"></keyboard-shortcut>
                <div class="hype-products__header">
                    <h3 class="main-page__block-header">Товары на хайпе <i class="cursor">|</i></h3>
                    <p class="label">Самое популярное, что есть сейчас в наличии</p>
                </div>
                <div class="hype-products__content">
                    <div class="navigation-arrow__block navigation__left-arrow" @click="prevProduct">
                        <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.292282 5.65703L5.94928 2.65793e-05L7.36328 1.41403L2.41328 6.36403L7.36328 11.314L5.94928 12.728L0.292282 7.07103C0.104811 6.8835 -0.000504437 6.62919 -0.000504414 6.36403C-0.000504391 6.09886 0.104811 5.84455 0.292282 5.65703Z" fill="black"/>
                        </svg>
                    </div>
                    <div class="navigation-arrow__block navigation__right-arrow" @click="nextProduct">
                        <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.071 7.071L1.414 12.728L0 11.314L4.95 6.364L0 1.414L1.414 0L7.071 5.657C7.25847 5.84453 7.36379 6.09884 7.36379 6.364C7.36379 6.62916 7.25847 6.88347 7.071 7.071Z" fill="black"/>
                        </svg>
                    </div>
                    <div class="hype-products__viewport">
                        <div
                            class="hype-products__track"
                            :style="trackStyle"
                            ref="trackRef"
                        >
                    <router-link
                        :to="{name: 'product-item', params: {code: product.code}}"
                        class="product-item__card"
                        :class="{ active: index === activeProductIndex }"
                        v-for="(product, index) in catPopular.items"
                        @mousemove="handleMove"
                        @mouseleave="resetCard">
                        <product-image-preview
                            :headerImage=setImageThumbURL(product.imageUrl)
                            :images=product.images
                            :actProduct="product"
                            :isShowBtn="false"
                        ></product-image-preview>
                        <span class="discount-value" v-if="getDiscountValue(product.common_price, product.sale_price)">{{ getDiscountValue(product.common_price, product.sale_price) }}</span>
                        <div class="category-head-info">
                            <p class="category-item-name">{{ product.product_name }}</p>
                            <p class="category-item-size">{{ sizes[product.size_name] }}</p>
                        </div>
                        <div class="category-item-price">
                            <div class="sale-block" v-if="product.sale_price !== 0 && product.sale_price < product.common_price">
                                <p class="sale-price">{{ product.sale_price }}&#8381;</p>
                                <p class="default-price">{{ product.common_price }}&#8381;</p>
                            </div>
                            <div class="default-block" v-else>
                                <p class="sale-price">{{ product.common_price }}&#8381;</p>
                            </div>
                        </div>
                    </router-link>
                        </div></div>
                </div>
            </div>

            <div class="search-jersey__wrapper">
                <div class="trending_searches__container">
                    <div class="section-header">
                        <h2>Трендовые запросы:</h2>
                    </div>
                    <div class="ts__item" v-for="searchTip in trendingSearches" @click="searchText = searchTip">
                        <span>{{ searchTip }}</span>
                    </div>
                </div>
                <div class="search__block">
                    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.3738 15.46L20.6568 19.742L19.2418 21.157L14.9598 16.874C13.3665 18.1512 11.3848 18.8459 9.34277 18.843C4.37477 18.843 0.342773 14.811 0.342773 9.84302C0.342773 4.87502 4.37477 0.843018 9.34277 0.843018C14.3108 0.843018 18.3428 4.87502 18.3428 9.84302C18.3457 11.885 17.651 13.8668 16.3738 15.46ZM14.3678 14.718C15.6369 13.4129 16.3456 11.6634 16.3428 9.84302C16.3428 5.97602 13.2098 2.84302 9.34277 2.84302C5.47577 2.84302 2.34277 5.97602 2.34277 9.84302C2.34277 13.71 5.47577 16.843 9.34277 16.843C11.1632 16.8459 12.9127 16.1371 14.2178 14.868L14.3678 14.718Z" fill="#1C1C1C"/>
                    </svg>
                    <div class="search__input">
                        <input type="text" name='search' id="search" v-model="searchText" ref="searchInput">
                        <div class="search__placeholder-text" v-if="!searchText" @click="focusSearch">{{ typedText }}</div>
                        <div class="search__button" @click="enterSearch(searchText)">
                            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 1V15M1 7L7 1L13 7" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Найти</span>
                        </div>
                    </div>
                </div>
            </div>

            <featured-categories></featured-categories>

            <div class="popular-teams__container" v-reveal>
                <h3 class="main-page__block-header" style="margin-right: 10px">Популярные команды:</h3>
                <div class="popular-teams__leagues-navigation">
                    <div
                        class="league-item__block"
                        :class="{ active: index === activeLeagueIndex }"
                        v-for="(item, index) in teamsNavigate"
                        :key="item.short_name"
                        @click="selectLeague(index)"
                    >
                        {{ item.short_name }}
                    </div>
                </div>
                <div class="popular-teams__clubs-navigation">
                    <div
                        class="club-item__block"
                        v-for="club in activeLeague.clubs"
                        :key="club.en_name"
                        :style="{
                            '--club-bg': lightenColor(club.colours[0], 10),
                            '--club-color': darkenColor(club.colours[0], 20, club.colours[1])
                        }"
                        @click="enterSearch(club.name)"
                    >
                        <div class="club-item__color_item"></div>

                        <span>{{ club.name }}</span>
                    </div>
                </div>
            </div>

            <div class="new-products__container" v-reveal>
                <keyboard-shortcut :description="'К товарам'" :keys="['Ctrl L']" :is-typing="true" :is-mini="false"></keyboard-shortcut>
                <div class="new-products__header">
                    <h3 class="main-page__block-header">Новинки <i class="cursor">|</i></h3>
                    <p class="label">Самое свежее обновление на сайте</p>
                </div>
                <p class="new-products__last-update" v-if="products[0]">Обновлено: {{products[0]['Дата последнего изменения']}}</p>
                <div class="new-products__content">
                    <div class="new-products__items">
                        <router-link
                            :to="{name: 'product-item', params: {code: product['Код']}}"
                            class="product-item__card"
                            v-for="product in products.slice(0,9)">
                            <product-image-preview
                                :headerImage=setImageThumbURL(product.imageUrl)
                                :images=product.images
                                :actProduct="product"
                                :isShowBtn="false"
                            ></product-image-preview>
                            <span class="discount-value" v-if="getDiscountValue(product['Обычная цена'], product['Цена по скидке'])">{{ getDiscountValue(product['Обычная цена'], product['Цена по скидке']) }}</span>
                            <div class="category-head-info">
                                <p class="category-item-name">{{ product['Название продукта'] }}</p>
                                <p class="category-item-size">{{ sizes[product['Размер']] }}</p>
                            </div>
                            <div class="category-item-price">
                                <div class="sale-block" v-if="product['Цена по скидке'] !== 0 && product['Цена по скидке'] < product['Обычная цена']">
                                    <p class="sale-price">{{ product['Цена по скидке'] }}&#8381;</p>
                                    <p class="default-price">{{ product['Обычная цена'] }}&#8381;</p>
                                </div>
                                <div class="default-block" v-else>
                                    <p class="sale-price">{{ product['Обычная цена'] }}&#8381;</p>
                                </div>
                            </div>
                        </router-link>
                        <div class="other-products__block">
                            <div
                                class="other-products__jersey-background"
                                :style="{
                                    backgroundImage: otherProductsImages.length
                                        ? `url(${otherProductsImages[currentOtherProductImage]})`
                                        : 'none'
                                }"
                            >
                            </div>
                            <div class="other-products__container">
                                <div class="other-products__button">
                                    <div class="other-products__icon">
                                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.37886 0.600002H7.74282V6.96396M7.30088 1.04194L0.848533 7.49429" stroke="black" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="square"/>
                                        </svg>
                                    </div>
                                    <p v-if="!isMobile">Смотреть ещё</p>
                                    <p v-else>Перейти</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="baller-socials__container" v-reveal>
                <div class="blog-article__container-outer">
                    <div class="blog-article__container" v-if="latestArticle">
                        <div v-if="latestArticle?.image" class="blog-article__background" :style="`background-image: url(${latestArticle.image})`"></div>
                        <div class="blog-article__content">
                            <div class="blog-article__header">
                                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="26" viewBox="0 0 102 26" fill="none"><path d="M85.5238 19.5114C88.3622 19.5114 90.1267 18.3591 91.1239 17.3603C92.2747 16.2078 92.8118 14.825 92.8118 13.903H89.5129C89.206 14.9786 88.0553 16.592 85.5238 16.592C82.9922 16.592 81.2277 14.9018 81.2277 12.4433C81.2277 9.98482 82.9922 8.29462 85.5238 8.29462C87.9019 8.29462 89.206 9.75434 89.5129 10.9836H93.6556L96.2639 5.68248H96.6474V10.9836H98.4119L101.941 3.76257H91.8911V8.21856H91.5076C90.6636 6.75884 88.6691 5.37595 85.5238 5.37595C80.9208 5.37595 78.0058 8.21856 78.0058 12.4441C78.0058 16.6696 81.151 19.5121 85.5238 19.5121V19.5114Z" fill="#00C78B"></path><path d="M7.55575 5.37048C5.39146 5.37048 3.53713 6.01226 2.19577 7.22365C0.800961 8.48161 0.0655823 10.2758 0.0655823 12.4107C0.0655823 14.5455 0.800961 16.3397 2.19577 17.5977C3.53868 18.8091 5.39146 19.4508 7.55575 19.4508C10.4523 19.4508 12.2121 18.3038 13.1776 17.3424C14.3392 16.1861 14.8577 14.7892 14.8577 13.9154V13.8526H11.5728L11.5604 13.8991C11.5535 13.9263 10.8049 16.5345 7.55575 16.5345C5.01719 16.5345 3.3124 14.8761 3.3124 12.4107C3.3124 9.94521 5.01719 8.28682 7.55575 8.28682C10.8049 8.28682 11.5527 10.8958 11.5604 10.9222L11.5728 10.9688H14.8577V10.9059C14.8577 10.0337 14.3377 8.63526 13.1776 7.47897C12.2121 6.51747 10.4539 5.37048 7.55575 5.37048Z" fill="#00C78B"></path><path d="M16.4369 19.1769H19.5753V8.50488H26.7702V19.1776H29.9085V5.64441H16.4369V19.1776V19.1769Z" fill="#00C78B"></path><path d="M44.4518 7.22365C43.1089 6.01226 41.2561 5.37048 39.0919 5.37048C36.9275 5.37048 35.0748 6.01226 33.7318 7.22365C32.3386 8.48161 31.6017 10.2758 31.6017 12.4107C31.6017 14.5455 32.337 16.3397 33.7318 17.5977C35.0748 18.8091 36.9275 19.4508 39.0919 19.4508C41.2561 19.4508 43.1089 18.8091 44.4518 17.5977C45.8451 16.3397 46.582 14.5455 46.582 12.4107C46.582 10.2758 45.8466 8.48161 44.4518 7.22365ZM43.3351 12.4107C43.3351 14.8761 41.6304 16.5345 39.0919 16.5345C36.5532 16.5345 34.8484 14.8761 34.8484 12.4107C34.8484 9.94521 36.5532 8.28682 39.0919 8.28682C41.6304 8.28682 43.3351 9.94521 43.3351 12.4107Z" fill="#00C78B"></path><path d="M64.1737 8.50487H69.3679V19.1754L72.5063 19.2041V8.50487H77.7004V5.64441H64.173V8.50487H64.1737Z" fill="#00C78B"></path><path d="M56.9099 5.37052C54.4644 5.37052 52.806 6.35143 51.7723 7.93298H51.4996V5.64212H48.3465V24.2375H51.4996V16.876H51.7723C52.8053 18.4576 54.4635 19.2756 56.9099 19.2756C60.7969 19.2756 63.5966 16.4127 63.5966 12.3766C63.5966 8.3404 60.796 5.36896 56.9099 5.36896V5.37052ZM56.0677 16.3304C53.5135 16.3304 51.7995 14.8583 51.7995 12.4053C51.7995 9.95223 53.5112 8.31557 56.0677 8.31557C58.624 8.31557 60.3358 9.86997 60.3358 12.323C60.3358 14.7761 58.5953 16.3304 56.0677 16.3304Z" fill="#00C78B"></path></svg>
                                <typing-text class="blog-article__new-post" text="Последний материал / Блог Baller"></typing-text>
                            </div>
                            <div class="blog-article__bottom">
                                <p v-if="latestArticle?.title">{{ latestArticle.title }}</p>
                                <div class="blog-article__button-items">
                                    <a class="blog-article__button target" :href="`${latestArticle.url}`" target="_blank">Читать</a>
                                    <router-link class="blog-article__button" :to="latestArticle.url">К покупкам</router-link>
                                </div>
                            </div>
                        </div>
                        <div class="blog-article__overlay">
                            <div class="rect-overlay" v-for="(index, i) in 10" :style="`opacity: ${0.25-i*0.025}`"></div>
                        </div>
                    </div>
                </div>
                <div class="baller-social-media__container">
                    <h3 class="main-page__block-header" style="text-align: left">Stay tuned</h3>
                    <div class="baller-social__items">
                        <a class="baller-social__item" v-for="s in socials" :href="s.link"
                             :style="{
                                '--item-color': s.color,
                                '--item-light': lightenColor(s.color, 18),
                                '--item-dark': darkenColor(s.color, 20, s.color)
                            }"
                        >
                            <div class="baller-social__icon" v-if="s.icon" v-html="s.icon"></div>
                            <typing-text :text="s.name" :typing-speed="80" restart-delay="8000"></typing-text>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <footer-default></footer-default>
    </div>
</template>

<style scoped src="./style.scss" lang="scss"></style>